import WebSocket from './src/web-socket'
// import type {} from './src/constant'
// import type {} from './src/interfaces'
// import type {} from './src/types'

const webSocket = new WebSocket()

export default webSocket
